import { render } from "./CostCurrencySettings.vue?vue&type=template&id=18f590df&scoped=true"
import script from "./CostCurrencySettings.vue?vue&type=script&lang=js"
export * from "./CostCurrencySettings.vue?vue&type=script&lang=js"

import "./CostCurrencySettings.vue?vue&type=style&index=0&id=18f590df&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f590df"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QTabs,QTab,QInput,QTable});
